import { ref } from "vue";
import { showToast } from "vant";
import Recorder from "recorder-core";
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/extensions/waveview";
import { Env } from "@voghion/fe-util";
import { authorize, Scope } from "@voghion/native-api";
import { checkApi } from "@/views/AskShop/utils/checkApi";

Recorder.CLog = function () {};

export interface AudioMessage {
  url: string;
}

const env = Env.getInstance();

export function useAudioRecorder(options = {}) {
  let wave;
  let recBlob: any;
  const recwave = ref(null);
  const audioLevel = ref(0);
  const recorder = Recorder({
    type: "mp3", //录音格式，可以换成wav等其他格式
    sampleRate: 16000, //录音的采样率，越大细节越丰富越细腻
    bitRate: 16, //录音的比特率，越大音质越好
    onProcess: (
      buffers: any,
      powerLevel: any,
      bufferDuration: any,
      bufferSampleRate: any,
      newBufferIdx: any,
      asyncEnd: any,
    ) => {
      audioLevel.value = powerLevel;
      //录音实时回调，大约1秒调用12次本回调
      //可实时绘制波形，实时上传（发送）数据
      if (wave) {
        wave.v.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate);
      }
    },
  });
  if (!recorder) {
    showToast("Not Support Record");
    return;
  }

  const open = () => {
    return new Promise<boolean>((resolve) => {
      recorder.open(
        () => {
          if (recwave?.value) {
            //创建音频可视化图形绘制对象
            wave = Recorder.WaveView({ elem: recwave.value });
          }
          resolve(true);
        },
        async (msg: any, isUserNotAllow: any) => {
          console.log(isUserNotAllow ? "UserNotAllow，" : "") +
            "无法录音:" +
            msg;

          if (env.isIOS) {
            const res = await checkApi(authorize, { scope: Scope.Record });
            if (res?.data) {
              await authorize({ scope: Scope.Record });
            }
          }
          resolve(false);
        },
      );
    });
  };
  const close = () => {
    recorder.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
    // recorder = null;
  };

  const startRecord = () => {
    recorder.start();
  };

  const stopRecord = () => {
    if (!recorder) {
      console.error("未打开录音");
      return;
    }
    return new Promise<Blob | undefined>((resolve) => {
      recorder.stop(
        (blob, duration) => {
          //blob就是我们要的录音文件对象，可以上传，或者本地播放
          recBlob = blob;
          //简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          const localUrl = (window.URL || webkitURL).createObjectURL(blob);
          console.log("录音成功", blob, localUrl, "时长:" + duration + "ms");
          resolve(recBlob);
        },
        (err) => {
          console.error("结束录音出错：" + err);
          resolve(undefined);
        },
      );
    });
  };

  const isOpen = () => {
    return Recorder.IsOpen();
  };

  return {
    wave,
    recBlob,
    recwave,
    recorder,
    startRecord,
    stopRecord,
    open,
    close,
    audioLevel,
    isOpen,
  };
}
